import styled from 'styled-components';
import { animated } from 'react-spring';
import { colors } from '../../constants';

export const TextTransitionWrapper = styled(animated.div)`
    flex: 1;
    overflow-x: hidden;
    color: ${colors.greenDark};
`;
